module.exports = __webpack_public_path__ + "static/media/bn.f6d5f400.svg";